module.exports = __webpack_public_path__ + "static/owner-829524f59b4c0fa2da883a3d21ac3411.jpg";